import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Query, QueryType } from "./flow-builder.reducer";

export interface GroupsSettings {
  query: Query;
}

interface GroupState {
  group: GroupsSettings;
  availableTags: string[];
  groupQueryErrors: Record<string, any>;
  showGroupsErrors: boolean;
}

const defaultGroupSettingsState = {
  query: {
    type: QueryType.ANY,
    statements: [],
  },
};

const initialState: GroupState = {
  group: defaultGroupSettingsState,
  availableTags: [],
  groupQueryErrors: {},
  showGroupsErrors: false,
};

const groupSettingsSlice = createSlice({
  name: "groupSettings",
  initialState,
  reducers: {
    setShowGroupsErrors(state, action: PayloadAction<boolean>) {
      if (!Object.keys(state.groupQueryErrors).length)
        state.showGroupsErrors = false;
      else state.showGroupsErrors = action.payload;
    },
    setGroupsSettings(state, action: PayloadAction<GroupsSettings>) {
      state.group = action.payload;
    },
    addGroupQueryError(state, action: PayloadAction<string>) {
      state.groupQueryErrors[action.payload] = true;
    },
    removeGroupQueryError(state, action: PayloadAction<string>) {
      delete state.groupQueryErrors[action.payload];
    },
    setAvailableTags(state, action: PayloadAction<string[]>) {
      state.availableTags = action.payload;
    },
    clearGroupPanelErrors(state) {
      state.groupQueryErrors = {};
    },
    setSettingsToDefault(state) {
      state.group = defaultGroupSettingsState;
    },
  },
});

export const {
  setGroupsSettings,
  addGroupQueryError,
  removeGroupQueryError,
  clearGroupPanelErrors,
  setShowGroupsErrors,
  setAvailableTags,
  setSettingsToDefault,
} = groupSettingsSlice.actions;

export default groupSettingsSlice.reducer;
